// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"782a6c75","465":"d30af89f","939":"8fc9a830"}[chunkId] + ".chunk.css";
};